<template>
  <div v-show="show" :style="{ 'z-index': (currentZIndex-1)}">
    <div :style="{ 'z-index': (currentZIndex)}" class="dimmed_black" style="top:0;display:block;"></div>

    <div
      :style="{ 'z-index': (currentZIndex+1)}"
      class="rew19_popContainer big"
      id="pop_cancelAro"
      style="display:block;"
    >
      <div class="rew19_popup_wrap">
        <h2>
          <span class="rew19_basketList_tit">정기구매 취소 정산내역</span>
          <button class="rew19_basketList_btn" @click="onClose">
            <span>닫기</span>
          </button>
        </h2>
      </div>
      <div class="rew19_popup_cont">
        <dl class="rew19_select_table">
          <dt>
            <span class="rew19_table_tit">주문 정보</span>
          </dt>
          <dd>
            <ul class="rew19_oneline_stress">
              <li>
                <em class="stress_type2">진행일</em>
                <span class="variable">{{viewData.regdate}}</span>
              </li>
              <li>
                <em class="stress_type2">진행 회차</em>
                <span class="variable">{{viewData.payment_count}}</span>
              </li>
              <li>
                <em class="stress_type2">할인율</em>
                <span class="variable">{{viewData.saving_percentage}}%</span>
              </li>
            </ul>
          </dd>

          <div v-for="(pd) in viewData.pd_list" :key="pd.pd_id">
            <dt>
                <span class="rew19_table_tit">[{{pd.pd_id}}] {{pd.pd_name_kr}}</span>
            </dt>
            <dd>
                <ul class="rew19_oneline_stress">
                <li>
                    <em class="stress_type2">수량</em>
                    <span class="variable">{{pd.pd_count}}</span>
                </li>
                <li>
                    <em class="stress_type2">합계</em>
                    <span class="variable">{{$fmt.WON(pd.total_amt)}} 원</span>
                </li>
                <li v-if="getMemberType() == 'DIST'">
                    <em class="stress_type2">SV/CSV</em>
                    <span class="variable">{{$fmt.PV(pd.pv)}} / {{$fmt.PV(pd.cv)}}</span>
                </li>
                <li>
                    <em class="stress_type2">반품수량</em>
                    <span class="variable">{{pd.pd_count}}</span>
                </li>
                <li>
                    <em class="stress_type2">할인금액</em>
                    <span class="variable">{{$fmt.WON(pd.saving_amt)}} 원</span>
                </li>
                </ul>
            </dd>
          </div>
        </dl>

        <ul class="rew19_dotList topLine">
          <li>고객님의 정기구매 철회에 따른 정산 금액은 {{$fmt.WON(viewData.cancel_amt)}}원 입니다.</li>
          <li>결제정보를 입력 후 해당 내역을 결제해 주시기 바랍니다.</li>
        </ul>
      </div>
      <!--//rew19_popup_cont-->

      <div class="rew19_popup_btn">
        <button class="rew19_popFull activation" @click="onClose">닫기</button>
      </div>
    </div>
  </div>
</template>
<script>
import AroBase from '@/components/base/AroBase';
import * as ErrMsg from "@/utils/error_msg";

export default {
  name: "AroCancelDialog",
  components: {},
  extends: AroBase,
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentZIndex: 2000,

      viewData: {
      }
    };
  },
  watch: {
    show(show) {
      this.$modalAfterTreat(show);

      show &&
        this.$nextTick(() => {
          let _this = this;
          _this.currentZIndex = _this.$getDimmMaxIndex() + 2;

          this.$el.focus();
        });
    }
  },
  updated: function () {
    this.$nextTick(function () {
      $(".rew19_popContainer.big .rew19_popup_cont").css('height', $(window).height() - 102);
    })
  },
  mounted() {
    let _this = this;
  },
  methods: {
    onClose(response) {
      let _this = this;

      _this.$emit("close", response, null);
    },
    onCancel() {
      this.onClose(false);
    },
    onOk() {
      this.onClose(true);
    },

    /**
     * API Request
     */

    /**
     * Local
     */
    initData: function(data) {
      let _this = this;

      _this.viewData = {
        ..._this.viewData,
        ...data
      };

    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/popup/AroCancelDialog.vue